import script from "./DiscountTagCom.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountTagCom.vue?vue&type=script&setup=true&lang=js"

import "./DiscountTagCom.vue?vue&type=style&index=0&id=30a32e89&lang=css"

const __exports__ = script;

export default __exports__